import * as React from "react";
import PuffLoader from "react-spinners/PuffLoader";
import { theme } from "../../theme";
import styled from "styled-components";

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingSpinner: React.FC = () => {
  return (
    <CenteredContainer>
      <PuffLoader color={theme.colors.primary} />
    </CenteredContainer>
  );
};

export default LoadingSpinner;
